<template>
  <el-dialog :title="type=='papers'?`批量发起任务作业`:'发起任务作业'" :visible.sync="dialogVisible" width="800px" :close-on-click-modal="false">
    <div class="paper-info" v-if="data.id">
      <div class="info-item">
        <span>试卷名称：{{ details.name }}</span>
      </div>
      <div class="info-item">
        <span>题量：{{ details.questionNumber }}</span>
        <span v-if="details.questionTypeNumber && details.questionTypeNumber.length > 0">
          （ <small v-for="item in details.questionTypeNumber" :key="item.questionType" class="items">
            <small>{{ item.questionTypeTag }}{{ item.number }}</small>
          </small> ）
        </span>
      </div>
    </div>
    <el-form :model="form" :rules="rules" ref="form" label-width="95px">
      <el-form-item label="任务类型：" prop="resourceLibType">
        <!-- <el-radio-group v-model="form.resourceLibType">
          <el-radio :label="10" class="width-16" style="margin-right: 40px;">训练</el-radio>
          <el-radio :label="20" class="width-16" style="margin-right: 40px;">测试</el-radio>
          <el-radio :label="30" class="width-16" style="margin-right: 40px;">考试</el-radio>
        </el-radio-group> -->
        <div class="modes">
          <div class="mode-item" :class="{ 'active': form.resourceLibType == 10 }" @click="form.resourceLibType = 10">
            <span class="iconfont icon-shangkexunlian"></span>
            <p>训练</p>
          </div>
          <div class="mode-item" style="margin-top: -4px;" :class="{ 'active': form.resourceLibType == 20 }" @click="form.resourceLibType = 20">
            <span class="iconfont icon-ceyan" style="font-size: 24px;"></span>
            <p>测验</p>
          </div>
          <div class="mode-item" :class="{ 'active': form.resourceLibType == 30 }" @click="form.resourceLibType = 30">
            <span class="iconfont icon-kaoshi"></span>
            <p>考试</p>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="任务名称：" prop="name" v-if="type == 'paper'">
        <el-input v-model="form.name" autocomplete="off" style="width: 400px;" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="已选试卷：" v-else-if="type == 'papers'">
        <span>共 {{ data.length }} 张</span>
      </el-form-item>
      <el-form-item label="我的题库：" v-else-if="type == 'select'" prop="testPaperId">
        <paper-list v-model="form.testPaperId" :clearable="false" multiple @change="paperChange"></paper-list>
        <span class="ml-10 color-999">
          注：如无试卷，请至<el-link type="primary" @click="$router.push({path:'/resource/papers'})" style="font-size: 14px;margin: -1px 1px 0;">我的题库</el-link>中添加
        </span>
      </el-form-item>
      <el-form-item label="发起对象：" prop="clazzIds">
        <clazz-list v-model="form.clazzIds" :clearable="true" :multiple="true"></clazz-list>
        <span class="ml-10 color-999">注：选择需要发起的班级</span>
      </el-form-item>
      <!-- <el-form-item label="说明：" prop="description">
        <el-input v-model="form.description" rows="3" autocomplete="off" clearable type="textarea" placeholder="多行输入"
          resize="none" show-word-limit :maxlength="300"></el-input>
      </el-form-item> -->
      <template v-if="form.resourceLibType == 20 || form.resourceLibType == 30">
        <el-form-item label="合格分数：" prop="passScore">
          <el-input-number size="mini" v-model="form.passScore" :precision="0"></el-input-number>
        </el-form-item>
        <el-form-item :label="`${func.learnType(form.resourceLibType)}时长：`" prop="duration">
          <el-input-number size="mini" v-model="form.duration" :min="1" :max="360" :step="5" :precision="0"></el-input-number><span class="ml-5">分钟</span>
        </el-form-item>
      </template>
      <el-form-item label="有效期：" prop="endTimeSpan" v-if="form.resourceLibType == 10 || form.resourceLibType == 20">
        <el-input-number size="mini" v-model="form.endTimeSpan" :min="1" :step="0.5"></el-input-number><span class="ml-5">小时</span>
      </el-form-item>
      <!-- <template v-if="form.resourceLibType == 3">
        <el-form-item label="每关题数：" prop="avgQuestion">
          <el-input-number size="mini" v-model="form.avgQuestion" :min="1" :max="20" :precision="0"></el-input-number>
        </el-form-item>
        <el-form-item label="提升到：" prop="passScore">
          <el-input-number size="mini" v-model="form.passScore" :min="60" :max="100" :step="5"
            :precision="0"></el-input-number><span class="ml-5">分为合格</span>
        </el-form-item>
      </template> -->
    </el-form>
    <ul class="item-list type-des">
      <template v-if="form.resourceLibType == 10">
        <li>
          <div class="keys">训练任务规则：</div>
          <div class="values">
            <p>将试卷的题自动分为5题一关，训练者每关全对才能继续下一关，直到最后全部过关。错题重复，适合强化内容，建议100题以内的作业。</p>
            <p>注：训练任务中<span class="color-red">仅包含单选、多选、判断、排序相关题型</span>，其他题目将不会被加入。</p>
          </div>
        </li>
      </template>
      <template v-if="form.resourceLibType == 20">
        <li>
          <div class="keys">测验任务规则：</div>
          <div class="values">与驾照考试模式相同，测验者每做一题系统立即反馈对错及答案，全部做完后出测验结果测验任务规则:错题不重复做，适合检查学习情况，建议100题以内的作业。</div>
        </li>
        <li>
          <div class="keys">设定时长：</div>
          <div class="values">为完成测验的时长，以测验者开始测验的时间为开始时间。任务发起后，测验者即可进入测验。</div>
        </li>
      </template>
      <template v-if="form.resourceLibType == 30">
        <li>
          <div class="keys">考试任务规则：</div>
          <div class="values">与线下考试模式相同，考试者做错系统不提示，考试者在考试时间结束后不能再答，系统在考试结全部结束后出考试结果。适合考核学生成绩，建议100题以内的作业。</div>
        </li>
        <li>
          <div class="keys">设定时长：</div>
          <div class="values">为考试的时长，以教师发起时间为考试开始时间。</div>
        </li>
      </template>
    </ul>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="confirm" v-loading="loading" :disabled="loading">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  components: {
  },
  props: {
    value: "",
    data: {
      type: Object,
      default: () => { return {} },
    },
    type: "",
    paper: {
      type: Object,
      default: () => { return {} },
    },
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      initForm: {
        resourceLibType: 10,
        name: "",
        description: "",
        avgQuestion: 5,
        passScore: 85,
        duration: 60,
        useRange: 0,
        clazzIds: [],
        clazzs: [],
        testPaperId: [],
        endTimeSpan: 48,
      },
      form: {},
      rules: {
        name: [
          { required: true, message: '请输入名称' },
        ],
        avgQuestion: [
          { required: true, message: '请输入' },
        ],
        passScore: [
          { required: true, message: '请输入' },
        ],
        duration: [
          { required: true, message: '请输入' },
        ],
        clazzIds: [
          { required: true, message: '请选择发起对象' },
        ],
        testPaperId: [
          { required: true, message: '请选择试卷' },
        ]
      },
      details: {},
    }
  },
  watch: {
    value(val) {
      this.dialogVisible = this.value;
    },
    dialogVisible(val) {
      if (val) {
        this.setData()
      } else {
        this.$emit('callback', 'hide');
      }
    },
  },
  created() {
  },
  mounted() {

  },
  methods: {
    setData() {
      if (this.type == "paper") {
        this.form = this.func.depCopy(this.initForm);
        this.form.resourceLibType = 10;
        this.form.useType = 1;
        this.form.name = (this.data.name || "") + `(${this.func.formatDate(new Date(), "MMddHHmm")})`;
        this.form.avgQuestion = 5;
        this.form.testPaperId = [this.data.id];
      } else if (this.type == "papers") {
        this.form = this.func.depCopy(this.initForm);
        this.form.resourceLibType = 10;
        this.form.useType = 1;
        this.form.avgQuestion = 5;
        this.form.testPaperId = this.data.map(item => { return item.id });
        if (this.data.length == 1) {
          this.form.name = this.data[0].name || "";
        }
      } else {
        this.form = Object.assign(this.initForm, this.data);
        this.form.name = (this.data.name || "") + `(${this.func.formatDate(new Date(), "MMddHHmm")})`;
      }
      if (this.$refs["form"]) {
        this.$refs["form"].resetFields();
      }
      this.getPaperDetails();
    },
    confirm() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let params = this.func.depCopy(this.form);
          params.clazzs = params.clazzIds.map(id => {
            return {
              id,
            }
          })
          delete params.clazzIds;
          if (params.resourceLibType == 10 || params.resourceLibType == 11) {
            params.passScore = 0;
            params.duration = 0;
          }
          if (params.resourceLibType == 30) {
            params.endTimeSpan = null;
          } else {
            params.endTimeSpan = parseInt(params.endTimeSpan * 60);
          }
          if (typeof params.testPaperId == "string") {
            params.testPaperId = [params.testPaperId];
          }
          this.loading = true;
          this.https("post", "/api/ResourceLib/UseTestPaper", params).then(res => {
            if (res.success) {
              this.dialogVisible = false;
              // this.func.message("success", res.msg);
              this.$emit('callback', 'success', {
                id: res.response,
              });
              this.loading = false;
            } else {
              this.loading = false;
              this.func.message("error", res.msg);
            }
          }).catch(() => {
            this.loading = false;
          })
        } else {
          return false;
        }
      });
    },
    paperChange(data) {
      if (data instanceof Array) {
        if (data.length == 1) {
          this.form.name = data[0].name || "";
        } else {
          this.form.name = "";
        }
      } else if (data) {
        this.form.name = data.name = "";
      }
    },
    getPaperDetails() {
      this.details = {};
      if (!this.data.id) {
        return;
      }
      let params = {
        id: this.data.id,
      }
      this.https("get", "/api/TestPaper/GetTestPaper", params).then(res => {
        this.details = res.response || {};
        try {
          this.details.questionTypeNumber = JSON.parse(this.details.questionTypeNumber);
        } catch (error) {
          this.details.questionTypeNumber = [];
        }
        this.details.questionTypeNumber.map(item => {
          item.list = [];
          for (let key in item.difficulty) {
            let difficulty = key.split("star")[1];
            let temp = {
              difficulty,
              count: item.difficulty[key],
            }
            item.list.push(temp)
          }
        })
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.paper-info {
  padding: 0 0 0px;
  border-bottom: 1px solid #ddd;
  margin: 0 15px 20px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  & > .info-item {
    margin: 0 0 10px 0;
    color: #999;

    .items {
      margin-right: 5px;

      &:last-child {
        margin-right: 0px;
      }
    }
  }
}

.type-des {
  padding: 15px;
  background-color: #c2fdfb;
  border-radius: 4px;
  color: #04adc0;

  li {
    line-height: 1.6;

    .keys {
      min-width: 95px;
      text-align: right;
    }
  }
}

.modes {
  display: flex;
  justify-content: space-between;
  width: 200px;
  line-height: 1.5;
  align-items: center;

  .mode-item {
    color: #999;
    text-align: center;

    .iconfont {
      font-size: 22px;
    }

    &.active {
      color: #04adc0;
    }

    &:hover {
      cursor: pointer;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/pc/components/shared/LaunchTask.vue